import bemMixin from 'framework/mixins/bem';
import isMountedMixin from 'framework/mixins/is-mounted';
import uuidMixin from 'framework/mixins/uuid';


export default {
    mixins: [
        bemMixin('form-field'),
        uuidMixin,
        isMountedMixin,
    ],
    inheritAttrs: false,
    props: {
        hasFloatingLabel: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            default() {
                return `v-uid-${ this.uuid }`;
            },
        },
        value: {
            type: [Number, String],
            required: true,
        },

        label: {
            type: String,
            default: null,
        },
        placeholder: {
            type: String,
            default: null,
        },

        /** @type {IFormFieldState} */
        state: {
            type: Object,
            default() {
                return {
                    error: false,
                    required: false,
                    disabled: false,
                    focus: false,
                };
            },
        },

        /** @type {IFormFieldMessage}*/
        messages: {
            type: Object,
            default() {
                return {
                    error: [],
                };
            },
        },
    },
    data() {
        return {
            hasFocus: this.state.focus,
        };
    },
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(model) {
                this.$emit('input', model);
            },
        },
        rootClasses() {
            const classes = [
                ...this.bemFacets,
                this.bemIf(this.hasFloatingLabel, 'floating-label'),
                this.bemIf(this.state.required, 'is-required', 'is-optional'),
                this.bemIf(this.state.disabled, 'is-disabled'),
                this.bemIf(this.state.error, 'has-error'),
                this.bemIf(this.hasValue, 'is-filled', 'is-empty'),
            ];

            // NOTE: Extend the form clesses adding also the floating variants
            if (this.hasFloatingLabel) {
                const isFloating = this.placeholder || this.hasValue || this.hasFocus || this.state.disabled;
                classes.push(this.bemIf(isFloating, 'is-floating'));
            }

            return [...classes, ...this.specificRootClasses];
        },
        inputAttrs() {
            const { id, state, value } = this;
            const { disabled, required } = state || {};

            return {
                id,
                name: id,
                disabled,
                required,
                value,
                ...this.specificInputAttrs,
            };
        },
        hasValue() {
            switch (true) {
                case Array.isArray(this.value):
                    return this.value.length;
                case (typeof this.value === 'boolean'):
                    return this.value != null;
                default:
                    return !!this.value;
            }
        },
    },
    methods: {
        onFocus() {
            this.hasFocus = true;
        },
        onBlur() {
            this.hasFocus = false;
        },
    },
};
